import React from 'react';
import HarbourNotice from '../../components/harbour/HarbourNotice';
import HarbourButton from '../../components/harbour/HarbourButton';

/**
 * The family portal's "could not load" state (frames 3474:145143 desktop,
 * 3307:2146 phone): an error notice and the gold Try again, the screen's one
 * action. Shared so every family page says it the same way.
 */
export default function FamilyLoadError({ onRetry }) {
  return (
    <div className="family-load-error">
      <HarbourNotice kind="error" title="We could not load this page right now">
        Check your connection, then try again.
      </HarbourNotice>
      <div>
        <HarbourButton kind="family" onClick={onRetry}>Try again</HarbourButton>
      </div>
    </div>
  );
}
